module.exports = __webpack_public_path__ + "img/dancing.7ca09f94.png";